import React from 'react';

// Shows only on the TEST copy of Resi (Netlify env REACT_APP_TEST_SITE=true). Never on the live site.
export default function TestSiteBanner() {
  if (process.env.REACT_APP_TEST_SITE !== 'true') return null;
  return (
    <div className="test-site-banner" style={{ position: 'sticky', top: 0, zIndex: 9999, background: '#c0392b', color: '#fff', textAlign: 'center', padding: '6px 10px', fontFamily: 'Roboto, sans-serif', fontWeight: 700, fontSize: 14, letterSpacing: 0.5 }}>
      TEST SITE - fake data only. Nothing here is real and no emails or texts are sent.
    </div>
  );
}